import { getPlayerTags } from 'js/hooks/user/server';

import { TAG_NAME, DEFAULT_FORM_DATA } from './constants';

export const prepareTag = formData => {
    const tagTmpl = {
        type: 'text',
        name: TAG_NAME
    };

    if (!formData.notifications) {
        return { ...tagTmpl, value: 'disabled' };
    }

    return { ...tagTmpl, value: formData.channel };
};

export const parseTag = tag => {
    if (!tag) {
        return DEFAULT_FORM_DATA;
    }

    switch (tag.value) {
        case 'email':
        case 'sms': {
            return {
                notifications: true,
                channel: tag.value
            };
        }
        default: {
            return DEFAULT_FORM_DATA;
        }
    }
};

export const fetchTag = async () => {
    const response = await getPlayerTags(TAG_NAME);
    const tags = response?.data?.tags || [];

    return tags.find(({ name }) => name === TAG_NAME);
};
